module.exports = __webpack_public_path__ + "static/media/logo.6b9f351f.svg";